const doc = document;
const win = window;
export { doc, win };
